import axios from 'axios'

const state = {
  currentUser: null,
  list: []
}

const getters = {}

const mutations = {
  add (state, text) {
    state.list.push({
      text,
      done: false
    })
  },
  remove (state, { user }) {
    state.list.splice(state.list.indexOf(user), 1)
  },
  toggle (state, user) {
    user.done = !user.done
  },
  setCurrentUser (state, user) {
    state.currentUser = user
  }
}

const actions = {
  async getCurrentUser ({ commit }) {
    const { data } = await axios.get('api/user')
    commit('setCurrentUser', data)
    return data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
